var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSettlementMockUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "27px",
    viewBox: "0 0 22 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.50110696e-12 7.531753e-13 14.5461426 2.55778038e-13 18.5 3 21.5 5.7043457 21.5 26.5 2.50110696e-12 26.5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 21.5,
    height: 26.5,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1145.000000, -882.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(1145.500000, 882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc",
    fillRule: "nonzero",
    strokeDasharray: 3,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(5.500000, 3.500000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5.31000553 C5.41741656,3.71735986 2.88751618,3.85824359 1.91029885,5.73265674 C0.93308153,7.60706989 2.07663948,8.91845767 5.3409727,9.66682008 C8.67043368,10.7256063 9.67052397,12.1174477 8.34124357,13.8423442 C7.01196316,15.5672408 4.39821531,15.6636412 0.5,14.1315456",
    id: "Path-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58404541,0.395507812 L5.58404541,19.296875",
    id: "Path-89"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSettlementMockUp);
export default __webpack_public_path__ + "static/media/ico_settlement-mock-up.42b3fe5088ba75aa837df00df485ef07.svg";
export { ForwardRef as ReactComponent };